import React from 'react';

const Partners = () => {
  return (
    <div>
      <h1>Yhteistyökumppanit</h1>
      <p>Kiitos kumppaneillemme, jotka mahdollistavat toimintamme.</p>
      {}
    </div>
  );
};

export default Partners;